/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { cn } from "../../lib/utils";
import { Spinner } from "./Spinner";

interface LoadingOverlayProps {
  isLoading: boolean;
  children: React.ReactNode;
  className?: string;
}

export function LoadingOverlay({
  isLoading,
  children,
  className,
}: LoadingOverlayProps) {
  return (
    <div className={cn("relative", className)}>
      {children}
      {isLoading && (
        <div className="absolute inset-0 bg-bg-base/30 backdrop-blur-sm flex items-start justify-center pt-20 z-10 rounded-2xl">
          <Spinner size="lg" />
        </div>
      )}
    </div>
  );
}
